<template>
  <div class="white-bg sub-section">
    <!-- Header -->
    <div class="sub-section-header">
      <a @click="$emit('hide')">
        <font-awesome-icon
          :icon="['fas', 'arrow-left']"
          size="lg"
          style="margin-bottom: 0.3rem;"
        />
      </a>
      &nbsp;&nbsp;
      <h3 style="display: inline-block;">
        {{ $t('account.acctDetails.personalInfo') }}
      </h3>
    </div>

    <!-- Main form -->
    <b-row>
      <!-- First name -->
      <b-form-group
        :label="$t('givenNames')"
        label-for="givenNames"
        class="col-xl-6"
      >
        <b-form-input
          id="givenNames"
          type="text"
          name="givenNames"
          v-model="personalInfo.givenNames"
          :state="givenNamesState"
          aria-describedby="givenNamesFeedback"
        ></b-form-input>
        <b-form-invalid-feedback id="givenNamesFeedback" class="align-left">
          {{ $t('account.personalInfo.givenNamesFeedB') }}
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- Last name -->
      <b-form-group
        :label="$t('lastNames')"
        label-for="lastNames"
        class="col-xl-6"
      >
        <b-form-input
          id="lastNames"
          type="text"
          name="lastNames"
          :state="lastNamesState"
          v-model="personalInfo.lastNames"
          aria-describedby="lastNamesFeedback"
        ></b-form-input>
        <b-form-invalid-feedback id="lastNamesFeedback" class="align-left">
          {{ $t('account.personalInfo.lastNamesFeedB') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <div class="ml-3">
        <b-button class="alt-primary-button" :disabled="!checkState" @click="updatePersonalInfo">
          {{ $t('save') }}
        </b-button>
        <b-button variant="light" class="acct-back-btn" @click="$emit('hide')">
          {{ $t('back') }}
        </b-button>
      </div>
    </b-row>
  
  </div>
</template>

<script>
import AccountMixin from '../../services/AccountMixin';

export default {
  data() {
    return {
      personalInfo: {
        givenNames: '',
        lastNames: ''
      }
    }
  },
  
  mixins: [AccountMixin],

  created() {
    const info = this.$store.getters['accountStore/getPersonalInfo'];
    _.assign(this.personalInfo, info);
  },


  computed: {
    givenNamesState() {
      return this.getGivenNamesState(this.personalInfo.givenNames);
    },

    lastNamesState() {
      return this.getLastNamesState(this.personalInfo.lastNames);
    },

    checkState() {
      return this.givenNamesState
          && this.lastNamesState;
    }
  },

  methods: {
    async updatePersonalInfo() {
      try {

        if(!this.checkState) return;
        
        await this.$store.dispatch(
          'accountStore/updatePersonalInfo',
          this.personalInfo
        );

        this.$notify({
          group: 'all',
          type: 'success',
          text: this.$t('account.personalInfo.updateOk'),
        });
      } catch (error) {
        console.log('Error', error);
        this.$notify({
          group: 'all',
          type: 'error',
          text: this.$t('account.personalInfo.updateErr'),
        });
      }
    },
  }
}
</script>